module.exports = __webpack_public_path__ + "7f5d9f7273469c7bf24bfdb9fd263e8b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-football-s.png
// module id = 1957
// module chunks = 0